import React from 'react';

export default () => (
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<path d="M13.3125 2V5.75L3 5.75V2L13.3125 2ZM9.5625 13.25L9.5625 17H3L3 13.25L9.5625 13.25ZM18 7.625V11.375L3 11.375V7.625L18 7.625Z" fill="currentColor"/>
</svg>
);
